import {
  CompanyAPIModel,
  CompanyEntityAPIModel,
  CompanyGroupAdditionalDetailsOrchApiModel,
  EmployeeAPIModel,
  ScreenConfigApiModel,
  SopSettingsAPIModel
} from '../../models/api.model'

export interface OnboardingState {
  company: CompanyAPIModel
  entities: CompanyEntityAPIModel[]
  sopSettings: SopSettingsAPIModel
  employees: EmployeeAPIModel[] /*subject to change- initial declaration*/
  screenConfigs: ScreenConfigApiModel[]
  others: CompanyGroupAdditionalDetailsOrchApiModel
  currentStep: number
  isEditMode: boolean
}

export const initialOnboardingState: OnboardingState = {
  company: undefined,
  entities: undefined,
  sopSettings: undefined,
  employees: undefined,
  screenConfigs: [],
  others: undefined,
  currentStep: 0,
  isEditMode: false
}
